import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import { MapPane } from '../components/MapPane';

import ManagerContext from '../context/ManagerContext';


export class MapPage extends Component {
    static displayName = MapPage.name;

    render() {
        let context = this.context;

        if (context.IsLoggedIn()) {
            return (
                <Container fluid>
                    <Row xs="1" >
                        <Col style={{height:'75vh'}}>
                            <MapPane></MapPane>
                        </Col>
                    </Row>
                </Container>
            );
        } else {
            return (
                <Container fluid>
                    <p>Please ensure you have logged in</p>
                </Container>
                );
        }

    }
}

MapPage.contextType = ManagerContext;
